exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-edit-category .app-select {\n  padding: 1rem;\n}\n.modal-edit-category .modal-edit-category-btn {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem;\n}\n", ""]);

// exports
